export type UserAddress = {
  firstName: string;
  lastName: string;
  address1: string;
  address2?: string;
  city: string;
  postcode: string;
  country: string;
  state?: string;
  phone?: string;
};

export type GetUserMeResponse = {
  userId: string;
  userName: string;
  email: string;
  displayName: string;
  subscribed: boolean;
  otpVerified: boolean;
  address?: {
    shipping: UserAddress;
    billing: UserAddress;
  };
} | null;

export type UpdateUserRequest = {
  email?: {
    emailAddress: string;
    subscribed: boolean;
  };
  phoneNumber?: string;
  phoneSubscribed?: boolean;
  address?: {
    shipping: UserAddress;
    billing: UserAddress;
  };
  profile?: {
    firstName: string;
    lastName: string;
    displayName: string;
  };
};

export type UpdateUserResponse = unknown;
